import currentExecutingScript from 'current-executing-script'
import 'html5-history-api/history.js'

// Need to import css-loader/css-base and style-loader/lib/addStyles 
// because otherwise extract text plugin
// would remove it, causing runtime problems.
import 'css-loader/lib/css-base'
import 'style-loader/lib/addStyles'
import '../css/genol-tvp.less'

window.history.setup('/', '!/', null)
// 
// For IE, we need to import the Promise
//import Es6Promise from 'es6-promise'
//Es6Promise.polyfill()

const currentScript = currentExecutingScript()
const container = currentScript.hasAttribute('data-container') ? currentScript.getAttribute('data-container') : 'genol-tvp-container'

let language = 'en'
if (currentScript.hasAttribute('data-lang')) {
  language = currentScript.getAttribute('data-lang')
} else {
  let elementsHtml = document.getElementsByTagName('html')
  if ((typeof elementsHtml) !== 'undefined' && elementsHtml.length > 0) {
    let elementHtmlLanguage = elementsHtml[0].getAttribute('lang')
    if ((typeof elementHtmlLanguage) !== 'undefined' && elementHtmlLanguage !== '') {
      language = elementHtmlLanguage
    }
  } 
}

// bootstrap application
require(['jquery', './startup', 'bootstrap', 'knockstrap'], function ($, startup) {

  $(function () {
    console.log('Creating binding in container ' + container)
    $('#' + container).append('<div data-bind="component: { name: \'ko-component-router\' }"></div>')
    // Startup the app _after_ we have inserted our container element.
    startup.startup(language)
  })

  console.log('Loaded')
})



// WEBPACK FOOTER //
// ./src/app/genol-tvp.js